export const ImageUrl = "https://calorie-finder.s3.eu-west-2.amazonaws.com/calorie"
export const API_BASE_URL = "https://api.thecaloriefinder.com"
export const BUCKET_URL = `https://calorie-finder.s3.eu-west-2.amazonaws.com/calorie`

